<template>
  <g-master :name="master.endpoint"
            @params="paramsTable"
            :endpoint="master.endpoint"
            :tableSetup="master.tableSetup"
            :parentData="jbParentData"
            modalWidth="70%"
  >
    <template slot="customButton">
      <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
    </template>
    <template slot="masterModal" slot-scope="{record}">
      <a-row :gutter="[16,16]">
        <a-col v-bind="colOptions">
          <g-dropdown endpoint="hierarchy_lookup"
                      :label="$t('Competencia')"
                      :formItemConfig="fiOptions"
                      :decorator="['id_h_competency', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                      :params="competencia">
          </g-dropdown>
        </a-col>
        <a-col v-bind="colOptions">
          <g-dropdown endpoint="hierarchy_lookup"
                      :label="$t('Grupo')"
                      :formItemConfig="fiOptions"
                      :decorator="['id_h_group', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                      :params="grupo">
          </g-dropdown>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item v-bind="fiOptions" :label="$t('Nivel')">
            <a-input-number style="width: 100%"
                            v-decorator="['level', { rules: [{ required: false }] }]"/>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item :label="$t('Observaciones')" v-bind="fiOptions">
            <a-textarea autoSize
                        v-decorator="['observations', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
          </a-form-item>
        </a-col>
      </a-row>
    </template>
  </g-master>
</template>
<script>
  export default {
    data () {
      return {
        competencia: {
          h_lookup_type: 'COMPETENCIA_TECNICA'
        },
        grupo: {
          h_lookup_type: 'GRUPO_COMPETENCIA'
        },
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        master: {
          endpoint: 'jobs_competency',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: '#', dataIndex: 'id', sorter: true},
              {title: 'ID competencia', dataIndex: 'id_h_competency', sorter: true},
              {title: 'Competencia', dataIndex: 'id_h_competency_desc', sorter: true},
              {title: 'ID grupo', dataIndex: 'id_h_group', sorter: true},
              {title: 'Grupo', dataIndex: 'id_h_group_desc', sorter: true},
              {title: 'Nivel', dataIndex: 'level', sorter: true},
              {title: 'Observaciones', dataIndex: 'observations', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado el', dataIndex: 'created_on', sorter: true},
              {title: 'Modificado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado el', dataIndex: 'modified_on', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'id_h_competency'},
            {name: 'id_h_group'},
            {name: 'level'},
            {name: 'observations'}
          ]
        },
        endpointExcel: 'jobs_competency_/downloadExcel',
        fileNameExcel: 'CompetenciaDeTrabajo',
        paramsT: {}
      }
    },
    props: ['jobId'],
    methods: {
      paramsTable (params) {
        this.paramsT = params
      }
    },
    computed: {
      jbParentData () {
        return {
          id_job: this.jobId
        }
      },
      paramsExcel () {
        return {...this.paramsT, columns: this.master.tableSetup.columns, ...this.jbParentData}
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Jobs/JobsCompetency.vue